(function () {
    'use strict';

    angular.module("imApp").factory("equipmentEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 239,
                    parameters: parms || {}
                });
            },
            listSelectWorkGroups: function (parms) {
                return $ihttp.post({
                    method: 2040,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 249,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
